import React from "react";
import "./Blogs.css";
import { FaMedium, FaDev, FaCode } from "react-icons/fa";

const blogs = [
  {
    title: "Getting Started with React Native",
    platform: "Coming Soon",
    icon: <FaCode />,
    link: "#",
    description:
      "My journey building mobile apps with React Native at Tabnet Security.",
  },
  {
    title: "Data Visualization with React.js",
    platform: "Coming Soon",
    icon: <FaCode />,
    link: "#",
    description: "Creating interactive dashboards and charts for analytics.",
  },
  {
    title: "Full Stack Development Tips",
    platform: "Coming Soon",
    icon: <FaCode />,
    link: "#",
    description: "Best practices from my experience at Creatosaurus.",
  },
];

const Blogs: React.FC = () => {
  return (
    <div className="blogs-container">
      <h2 className="blogs-title">✍️ My Blog Posts</h2>
      <p className="blogs-intro">
        A collection of my thoughts and tutorials on software development.
        Coming soon!
      </p>
      <div className="blogs-grid">
        {blogs.map((blog, index) => (
          <a
            href={blog.link}
            key={index}
            target="_blank"
            rel="noopener noreferrer"
            className="blog-card"
            style={{ "--delay": `${index * 0.2}s` } as React.CSSProperties}
          >
            <div className="blog-icon animated-icon">{blog.icon}</div>
            <div className="blog-info animated-text">
              <h3 className="blog-title">{blog.title}</h3>
              <p className="blog-description">{blog.description}</p>
              <span className="blog-platform">{blog.platform}</span>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default Blogs;
